//@author: travis
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { RateService } from "../../../services/rate.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-rate-group-dropdown")
@Component({
    selector: "s25-rate-group-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [hasFav]="false"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="false"
                [apiBean]="apiBean"
                [serverSide]="serverSide"
                [placeholder]="'Select a Rate Group'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                [ariaLabel]="ariaLabel"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25RateGroupDropdownComponent extends S25DropdownAbstract implements OnInit {
    constructor() {
        super();
    }

    ngOnInit() {
        RateService.getRateGroupItems().then((items) => {
            this.items = items;
            this.onLoad && this.onLoad();
            this.cd.detectChanges();
        });
    }
}
